import { popularComics } from "@/mocks/comicData";

const toneClass: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

export default function Popular() {
  return (
    <section id="popular" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-fire-line" />
              热门推荐
            </span>
            <h2 className="font-heading mt-4 text-3xl text-foreground-950 md:text-4xl">
              大家都在追的热门漫画
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
            以下为近期读者评分与热度靠前的连载作品，进入入口即可搜索或直接开读。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4">
          {popularComics.map((comic) => (
            <a
              key={comic.title}
              href="#entrance"
              className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-bold ${toneClass[comic.tone]}`}
                >
                  {comic.tag}
                </span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-bold text-background-50 backdrop-blur">
                  <i className="ri-star-fill text-accent-400" />
                  {comic.rating}
                </span>
              </div>

              <div className="p-4">
                <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">
                  {comic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600">{comic.chapter}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line" />
                    {comic.views} 阅读
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-bold text-primary-700">
                    立即阅读
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}